/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="94.3"
        viewBox="0 0 82.25 94.3"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M81 58.12v4H1.25v-4H81zM81 72.17v7H1.25v-7H81z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="m56.04 3.73 2.34.88c-6.27 16.74-28 16.26-34.32.48l-.19-.48 2.34-.88c5.23 14 23.95 14.69 29.66.44Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M23.96 0h-9.68a1.25 1.25 0 0 0-1.25 1.25v26.58a16.94 16.94 0 0 1-3.17 9.92l-8 11.07A10 10 0 0 0 0 54.63v33.8a5.77 5.77 0 0 0 5.66 5.87H36.5a5.77 5.77 0 0 0 5.66-5.87v-40.9a6 6 0 0 0-.39-2.13L25.13.81A1.24 1.24 0 0 0 23.96 0ZM15.5 2.5h7.56L39.5 46.27a3.6 3.6 0 0 1 .23 1.26v40.9a3.27 3.27 0 0 1-3.23 3.37H5.66a3.27 3.27 0 0 1-3.16-3.37v-33.8a7.41 7.41 0 0 1 1.39-4.34l8-11.08.26-.37a19.45 19.45 0 0 0 3.39-11Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M67.97 0h-9.68a1.24 1.24 0 0 0-1.17.81L40.5 45.4a6.17 6.17 0 0 0-.38 2.13v40.9a5.76 5.76 0 0 0 5.65 5.87H76.6a5.76 5.76 0 0 0 5.65-5.87v-33.8a9.93 9.93 0 0 0-1.86-5.81l-8-11.07a17 17 0 0 1-3.17-9.92V1.25A1.25 1.25 0 0 0 67.97 0Zm-8.81 2.5h7.56v25.33a19.41 19.41 0 0 0 3.65 11.38l8 11.08a7.41 7.41 0 0 1 1.39 4.34v33.8a3.27 3.27 0 0 1-3.15 3.37H45.72a3.26 3.26 0 0 1-3.15-3.37V47.27a3.81 3.81 0 0 1 .22-1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'LifePreserverVestIcon';

export default Icon;
